import React from 'react';

import { FormattedMessage } from '../../../util/reactIntl';
import { getDefaultSearchOrigin } from '../../../util/search';
import { ListingCard } from '../../../components';

import css from './ClassDetail.module.css';

/**
 * "Similar activities" -- real listings from the duck's same-category proximity query, on the shared
 * ListingCard (distance chips via the parent's saved location). Hidden when the query found nothing.
 */
const SimilarClasses = props => {
  const { listings = [], currentUser } = props;

  if (listings.length === 0) {
    return null;
  }

  const origin = getDefaultSearchOrigin(currentUser);

  return (
    <section className={css.similarSection}>
      <h2 className={css.similarTitle}>
        <FormattedMessage id="ClassDetailPage.similarTitle" />
      </h2>
      <p className={css.sectionSubtitle}>
        <FormattedMessage id="ClassDetailPage.similarSubtitle" />
      </p>
      <ul className={css.similarGrid}>
        {listings.map(listing => (
          <li key={listing.id.uuid} className={css.similarItem}>
            <ListingCard listing={listing} origin={origin} />
          </li>
        ))}
      </ul>
    </section>
  );
};

export default SimilarClasses;
